module.exports = __webpack_public_path__ + "static/media/1 06 nysgjerrig.3305dfe1.mp3";